module.exports = __webpack_public_path__ + "static/img/casino-pc-thum01.6b6e2e5.png";